import * as React from 'react';
export const eftposauSvg = React.forwardRef(function eftposauSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2E0F4C',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.827 8.514c-2.942 1.386-4.931 4.04-4.931 7.086 0 3.845 3.433 6.963 7.667 6.963 1.944 0 3.31-.463 4.908-1.455.17-.105.361-.184.487-.02.072.094.042.208-.013.312-1.746 3.304-5.297 5.6-9.282 5.6C10.773 27 6 22.075 6 16c0-3.469 1.557-6.563 3.989-8.58 1.826-1.514 6.406-1.723 7.838 1.094Z',
      fill: 'url(#bi_eftposau__a)',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M25.82 12.774c0 3.654-3.382 6.616-7.555 6.616-.606 0-2.25-.086-3.427-.652-.335-.16-.3-.362-.07-.46.534-.228 4.727-1.058 4.727-5.505 0-4.446-4.45-7.697-9.506-5.352A10.415 10.415 0 0 1 16.663 5c4.951 0 9.158 3.48 9.158 7.774Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_eftposau__a',
          x1: 16.093,
          y1: 19.626,
          x2: 11.761,
          y2: -1.979,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.14,
          stopColor: '#fff',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.75,
          stopColor: '#1F0038',
        }),
      ),
    ),
  );
});
eftposauSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var eftposau = {
  category: 'brand',
  colorable: false,
  name: 'eftposau',
  svg: eftposauSvg,
};
